export const interests = [
    "Space exploration",
    "STEAM subjects",
    "Sailing",
];